import { Stack } from "@mui/system";
import BillzTypographyHelptext from "./BillzTypographyHelptext";
import BillzTypography from "./BillzTypography";

const BillzLabeledTypograpthy = ({ text, label }) => {
    return (
        <Stack direction='column' spacing={0} marginBottom="5px">
            <BillzTypographyHelptext>{label}</BillzTypographyHelptext>        
            <BillzTypography color='black'>{text}</BillzTypography>
        </Stack>
    );
};

export default BillzLabeledTypograpthy;
